import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../Components/PageHeader/PageHeader';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { getAllEventAction } from '../../Redux/Actions/EventActions';

import MoU_signing_with_Water_Management_and_Plumbing_Skill_Council from '../../Assets/Images/Events/Water Management and Plumbing Skill Council/MoU signing with Water Management and Plumbing Skill Council (WMPSC).jpeg';
import Rethinking_Public_Spaces_Under_Flyover from '../../Assets/Images/Events/Rethinking Public Spaces Under Flyover/Rethinking Public Spaces Under Flyover.jpeg';
import Water_Management1 from '../../Assets/Images/Events/Water Management and Plumbing Skill Council/Water_Management1.jpg';
import Flyover_1 from '../../Assets/Images/Events/Rethinking Public Spaces Under Flyover/Flyover_1.jpg';
import Flyover_2 from '../../Assets/Images/Events/Rethinking Public Spaces Under Flyover/Flyover_2.jpg';

const Events = () => {

    const dispatch = useDispatch()
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
    const eventList = useSelector((e) => e?.EventReducer?.eventList)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        dispatch(getAllEventAction())
    }

    const [events, setEvents] = useState([
        {
            id: 1,
            date: '5',
            month: 'June 2025',
            title: 'MoU signing with Water Management and Plumbing Skill Council (WMPSC)',
            image: MoU_signing_with_Water_Management_and_Plumbing_Skill_Council,
            paragraph: null,
            path: '/events/MoU_signing_with_Water_Management_and_Plumbing_Skill_Council',
            gallery: [
                {
                    id: 1,
                    imgName: Water_Management1,
                    title: 'MoU signing with Water Management and Plumbing Skill Council (WMPSC)',
                },
            ]
        },
        {
            id: 2,
            date: '9',
            month: 'June 2025',
            title: 'Rethinking Public Spaces Under Flyover',
            image: Rethinking_Public_Spaces_Under_Flyover,
            paragraph: `On 9 June 2025, the Centre of Excellence for Urban Planning and Design at the School of Planning and Architecture, New Delhi, organized a dynamic half-day workshop titled “Rethinking Public Spaces under Flyovers” at the Institute’s Swami Vivekanand Sabhaghar. The event aimed to foreground the adaptive reuse of defunct and overlooked under-flyover spaces. Prof. Dr. V. K. Paul, Director of SPA Delhi, has been a visionary force behind the Centre of Excellence, championing innovative urban transformations through inclusive and sustainable public space initiatives. Under his leadership, COE-SPA Delhi has emerged as a national thought leader in reimagining neglected urban zones such as under-flyover spaces. Mrs. Isha Kalia, IAS, highlighted the “tremendous potential of these interstitial spaces for land value capture and community engagement,” while Dr. Vikram Singh, IPS (Retd.), emphasized that “well-planned under-flyover zones can significantly enhance urban safety.” Hon’ble PWD Minister Shri Parvesh Sahib Singh introduced Delhi’s proposed “Adopt-a-Flyover” policy, advocating their transformation into public assets such as play areas, gyms, and libraries. During the technical session chaired by Prof. Manoranjan Parida, Mr. Vivekanand Vivek (ADG, PWD) stressed the need for sustainable urban design, and Mr. Gurpawan Singh underlined the integration of safety in public space planning. The workshop concluded with a shared resolve to reimagine, reclaim, and repurpose these undervalued urban voids. A pilot study on this subject is set to be launched soon, positioning the initiative as a catalyst for meaningful urban change. The COE team—including Dr. Sewa Ram, Dr. Chetna Singh, and other committed faculty members—brings together a wealth of interdisciplinary expertise to lead impactful research, foster policy dialogue, and implement forward-thinking urban interventions.`,
            path: '/events/Rethinking_Public_Spaces_Under_Flyover',
            gallery: [
                {
                    id: 1,
                    imgName: Flyover_1,
                    title: 'Rethinking Public Spaces Under Flyover',
                },
                {
                    id: 2,
                    imgName: Flyover_2,
                    title: 'Rethinking Public Spaces Under Flyover',
                },
            ]
        }
    ]);

    return (
        <>
            <PageHeader
                title="Events"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    // { label: 'About', href: '/about' },
                    { label: 'Events' }
                ]}
            />
            <div className="container py-5">
                <h2 className="mb-4">Events</h2>
                {
                    isLoading ?
                        <div className='text-center'>
                            <Spinner animation="border" />
                        </div>
                        :
                        <div className="row g-4">
                            {eventList?.map((event, idx) => (
                                <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={idx}>
                                    <Link
                                        to={`${event?.title}`}
                                        state={event}
                                        className='text-decoration-none'
                                    >
                                        <div className="card event-card h-100">
                                            <div className="position-relative">
                                                <img
                                                    src={`https://api.coeupdspadelhi.in/${event?.image_urls[0]}`}
                                                    className="card-img-top"
                                                    alt={event.title}
                                                    style={{ height: 230 }}
                                                />

                                                <div className="event-date bg-black text-white text-center position-absolute">
                                                    {/* <h5 className="mb-0">{event.date}</h5> */}
                                                    <small>{event.eventDate}</small>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <h6 className="fw-bold">{event.title}</h6>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                }

            </div>
        </>
    );
};

export default Events;